const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://cantho-api.cgis.asia/",
        domainUserSide: "http://localhost:3001",
        domainAdminSide: "https://admin.cantho.cgis.asia",
        domainName: "",
        doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
        doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/wms",
  },
  production: {
      api: "https://cantho-api.cgis.asia/",
      domainUserSide: "http://cantho.cgis.asia",
      domainAdminSide: "https://admin.cantho.cgis.asia",
      domainName: "cantho.cgis.asia",
      doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
      doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/wms",
  },
};

module.exports = apiEnvironment[env];
